import React from 'react'

import cn from 'classnames'
import btnCss from 'Components/Button/Button.scss'
import cl from 'Components/StoreGallery/Gallery.scss'
import Button from './Button'
import { SVGArrow } from './SVGCollection'

type ImageModalProps = {
  imageUrls: string[]
  defaultSelected: number
  onClose?: (result: any) => void // received from ModalWrapper
}

type ImageModalState = {
  selected: number
}

const KEY_LEFT = 37
const KEY_RIGHT = 39

export class ImageModal extends React.Component<ImageModalProps, ImageModalState> {
  content: HTMLDivElement | null = null
  constructor (props: ImageModalProps) {
    super(props)
    this.state = {
      selected: props.defaultSelected
    }
  }

  componentDidMount () {
    this.content && this.content.focus()
  }

  componentDidUpdate () {
    this.content && this.content.focus()
  }

  handlePrev = () => {
    this.setState(state =>
      state.selected > 0
        ? { selected: state.selected - 1 }
        : null
    )
  }

  handleNext = () => {
    this.setState(state =>
      state.selected < this.props.imageUrls.length - 1
        ? { selected: state.selected + 1 }
        : null
    )
  }

  handleKeyDown = (e: React.KeyboardEvent) => {
    e.stopPropagation()
    switch(e.keyCode) {
      case KEY_LEFT:
        this.handlePrev()
        break
      case KEY_RIGHT:
        this.handleNext()
        break
      default:
        break
    }
  }

  render () {
    const prevEnabled = this.state.selected > 0
    const nextEnabled = this.state.selected < this.props.imageUrls.length - 1
    return (
      <div
        ref={ref => this.content = ref}
        tabIndex={-1} // this is necessary for keyDown to work, apparently
        onKeyDown={this.handleKeyDown}
        className={cl.imageModal}
      >
        {this.props.imageUrls.map((url, id) =>
          <div className={`${cl.imageHolder} ${this.state.selected === id ? cl.selected : ''}`}>
            <img key={url} src={url} />
            { prevEnabled && <div className={cl.reveal__prevButtonContainer}>
              <Button
                className={cn(btnCss.hollow, btnCss.flat, cl.prevButton)}
                renderIcon={{
                  ariaLabel: 'előző',
                  Icon: <SVGArrow width={40} height={40} />
                }}
                onClick={this.handlePrev}
              />
            </div> }
            { nextEnabled && <div className={cl.reveal__nextButtonContainer}>
              <Button
                className={cn(btnCss.hollow, btnCss.flat, cl.nextButton)}
                renderIcon={{
                  ariaLabel: 'következő',
                  Icon: <SVGArrow width={40} height={40} />
                }}
                onClick={this.handleNext}
              />
            </div> }
          </div>
        )}

      </div>
    )
  }
}
